module.exports = __webpack_public_path__ + "img/e.0ede8e6c.png";